export default "__VITE_ASSET__1826a75b__"